<template>
	<div style="color: green" v-if="assessment.testSummary.testChecks">
		<div
			class="testrankingbar d-flex align-items-center justify-content-between position-relative mt-5"
		>
			<div class="text-pos d-flex align-items-start">
				<div class="d-flex align-items-center">
					<span class="cp-datetext"> Min.&nbsp;Marks: </span>
					&nbsp;
					<span class="cp-asmnttext">
						{{ roundToTwo(assessment.testSummary.minTestMarks) }}
					</span>
				</div>
			</div>

			<div
				class="average-negative align-items-center"
				:style="[
					assessment.testSummary.avgTestMarks == 0 ? 'left: 0px' : '',
					assessment.testSummary.avgTestMarks &&
					assessment.testSummary.avgTestMarks ==
						assessment.testSummary.maxTestMarks
						? { right: 0 }
						: assessment.testSummary.avgTestMarks < 0
						? 'left:0px'
						: assessment.testSummary.avgTestMarks >
						  assessment.testSummary.maxTestMarks
						? 'right:0px'
						: {
								left:
									(assessment.testSummary.avgTestMarks /
										assessment.totalMarksOfTest +
										(hasNegative ? 0.1 : 0)) *
										90 +
									'%',
						  },
				]"
			>
				<div
					class="avg-marks"
					:style="
						assessment.testSummary.avgTestMarks ==
							assessment.testSummary.maxTestMarks &&
						assessment.testSummary.avgTestMarks != 0
							? 'right:0px'
							: assessment.testSummary.avgTestMarks == 0 ||
							  assessment.testSummary.avgTestMarks < 0
							? 'left:0px'
							: 'left:-40px'
					"
				>
					<span class="cp-datetext">TestAvg.&nbsp;Marks:</span>
					&nbsp;
					<span class="cp-asmnttext">
						{{ roundToTwo(assessment.testSummary.avgTestMarks) }}
					</span>
				</div>
			</div>

			<div class="text-pos d-flex align-items-end">
				<div class="d-flex align-items-center">
					<span class="cp-datetext"> Max.&nbsp;Marks: </span>
					&nbsp;
					<span class="cp-asmnttext">
						{{ roundToTwo(assessment.testSummary.maxTestMarks) }}
					</span>
				</div>
			</div>
			<template v-if="hasNegative">
				<div
					id="negative-circle"
					class="d-flex align-items-center justify-content-center positive-circle pointer negative-circle"
					:style="{
						left: (0.1 / assessment.totalMarksOfTest) * 84 + '%',
					}"
					@mouseenter="toggleNegativeMarks"
					@mouseleave="toggleNegativeMarks"
				>
					<img src="../assets/newdesign/jobsearch/negmark-dp.svg" alt="" />
					<div class="position-relative">
						<div class="negative-mark-box" v-if="showNegativeMarks">
							<div class="neg-txt-1 mb-2">Negative Mark</div>
							<template v-for="(attempts, mark) in marks">
								<div
									:key="mark"
									v-if="mark < 0"
									class="d-flex align-items-center justify-content-between"
								>
									<div class="neg-txt-2">
										Attempt
										{{ attempts.map((a) => a + 1).join(", ") }}
									</div>
									<div class="neg-red-txt">{{ mark }}</div>
								</div>
							</template>
						</div>
					</div>
				</div>
			</template>
			<template v-for="(attempts, marksInfo) in marks">
				<div
					v-if="marksInfo >= 0"
					class="d-flex align-items-center justify-content-center positive-circle pointer"
					:key="marksInfo"
					:class="[
						marksInfo > assessment.testSummary.avgTestMarks
							? marksInfo + 'cards'
							: 'negative-circle',
					]"
					:id="marksInfo + 'cards'"
					v-b-tooltip.hover.top="{
						title: 'Attempt ' + attempts.map((a) => a + 1).join(', '),
						delay: { show: 0, hide: 0 },
						animation: false,
					}"
					@mouseover="startMouseOver('cards', marksInfo, marksInfo)"
					@mouseleave="stopMouseOver('cards', marksInfo, marksInfo)"
					:style="[
						{
							left: hasNegative
								? (marksInfo / assessment.totalMarksOfTest + 0.1) * 84 + '%'
								: marksInfo >= 0
								? (marksInfo / assessment.totalMarksOfTest) * 96 + '%'
								: '5%',
						},
					]"
				>
					<span v-if="marksInfo >= 0" class="cp-asmnttext-new">
						{{ marksInfo }}
					</span>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		assessment: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			hasNegative: false,
			showNegativeMarks: false,
			marks: {},
		};
	},
	created() {
		this.marks = this.processMarks(this.assessment.marksList);
		this.hasNegative = this.assessment.marksList.some((m) => m < 0);
		this.processTest(this.assessment);
	},
	methods: {
		processMarks(marksList) {
			let marks = {};
			marksList.forEach((mark, index) => {
				if (marks[mark]) {
					marks[mark].push(index);
				} else {
					marks[mark] = [index];
				}
			});
			return marks;
		},
		toggleNegativeMarks() {
			this.showNegativeMarks = !this.showNegativeMarks;
			let negativeCircle = document.getElementById("negative-circle");
			if (this.showNegativeMarks) {
				negativeCircle.style.zIndex = "9993634999";
				negativeCircle.style.height = "45px";
				negativeCircle.style.width = "45px";
				negativeCircle.style.borderRadius = "30px";
			} else {
				negativeCircle.style.zIndex = "0";
				negativeCircle.style.height = "35px";
				negativeCircle.style.width = "35px";
				negativeCircle.style.borderRadius = "20px";
			}
		},
		roundToTwo(num) {
			return Math.round(num);
		},
		startMouseOver(type, j, marks) {
			const id = `${j}${type}`;
			const element = document.getElementById(id);

			if (element) {
				element.style.zIndex = "9993634999";
				element.style.height = "45px";
				element.style.width = "45px";
				element.style.borderRadius = "30px";

				let left = marks - 1;
				let right = marks + 1;
				// while (
				//   left > 0 &&
				//   this.assessment.testSummary.testChecks[left].present
				// ) {
				//   this.assessment.testSummary.testChecks[left--].subhovered = true;
				// }
				// while (
				//   right < this.assessment.testSummary.testChecks.length &&
				//   this.assessment.testSummary.testChecks[right].present
				// ) {
				//   this.assessment.testSummary.testChecks[right++].subhovered = true;
				// }
				this.$forceUpdate();
			}
		},

		stopMouseOver(type, j, marks) {
			const id = `${j}${type}`;
			const element = document.getElementById(id);

			if (element) {
				element.style.zIndex = marks >= 0 ? marks : 0;
				element.style.height = "35px";
				element.style.width = "35px";

				let left = marks - 1;
				let right = marks + 1;

				// while (
				//   left > 0 &&
				//   this.assessment.testSummary.testChecks[left].present
				// ) {
				//   this.assessment.testSummary.testChecks[left--].subhovered = false;
				// }
				// while (
				//   right < this.assessment.testSummary.testChecks.length &&
				//   this.assessment.testSummary.testChecks[right].present
				// ) {
				//   this.assessment.testSummary.testChecks[right++].subhovered = false;
				// }
				this.$forceUpdate();
			}
		},
		processTest(test) {
			test.testSummary["testChecks"] = this.generateTestChecks(test);
		},
		generateTestChecks(test) {
			const testChecks = [];

			for (let j = 0; j <= test.testSummary.maxTestMarks; j++) {
				testChecks[j] = this.checkTestMarkPresence(j, test.marksList);
			}

			return testChecks;
		},
		checkTestMarkPresence(mark, marksList) {
			return marksList.some((m) => mark === m);
		},
	},
};
</script>

<style>
.testrankingbar {
	box-sizing: border-box;
	height: 18px;
	margin: 30px;
	background: #20639b;
	border: 0.5px solid #c4c4c4;
	box-shadow: 0px 0px 5px rgb(86 86 86 / 20%);
	border-radius: 11px;
}

.average-negative {
	width: 10px;
	height: 21px;
	border-radius: 11px;
	position: absolute;
	background: #ffffff;
}

.avg-marks {
	position: absolute;
	align-items: center;
	display: flex;
	top: -32px;
}

.text-pos {
	position: relative;
	align-items: center;
	display: flex;
	top: 28px;
}

.cp-datetext {
	font-weight: 400;
	font-size: 12px;
	color: #6d6d6d;
}

.cp-asmnttext {
	font-weight: 600;
	font-size: 12px;
	color: #696969;
}

.positive-circle {
	width: 35px;
	height: 35px;
	border-radius: 20px;
	border: 4px solid white;
	background: #038e00;
	position: absolute;
}

.negative-circle {
	width: 35px;
	height: 35px;
	border-radius: 20px;
	border: 4px solid white;
	background: #eb0002;
	position: absolute;
}

.cp-asmnttext-new {
	font-weight: 600;
	font-size: 14px;
	color: rgba(255, 255, 255, 1);
}

.negative-mark-box {
	box-shadow: 0px 2px 16px 0px #00000040;
	background-color: #ffffff;
	border-radius: 8px;
	width: 180px;
	position: absolute;
	padding: 13px 10px;
	bottom: 22px;
	right: -144px;
}

.neg-txt-1 {
	font-family: "Lato", sans-serif;
	font-size: 14px;
	font-weight: 600;
	color: #3a3c40;
}

.neg-txt-2 {
	font-family: "Lato", sans-serif;
	font-size: 12px;
	font-weight: 500;
	color: #3a3c40;
}

.neg-red-txt {
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 600;
	color: #eb0002;
}
</style>
